var map = {
	"./_архив/1.png": "2343",
	"./_архив/2.png": "b8c5",
	"./_архив/3.png": "8d60",
	"./_архив/spilka250x82.png": "fdc0",
	"./_архив/vchasno.png": "c10b",
	"./backgrounds/artboard.jpg": "954d",
	"./backgrounds/artboard.webp": "4b25",
	"./backgrounds/artboard2.jpg": "7cd4",
	"./backgrounds/artboard2.webp": "5bde",
	"./backgrounds/artboard3.jpg": "2128",
	"./backgrounds/artboard3.webp": "18b9",
	"./carmini.png": "f292",
	"./carmini.webp": "ae32",
	"./explanation_slides/1_de.jpg": "c0be",
	"./explanation_slides/1_de.webp": "94cb",
	"./explanation_slides/1_en.jpg": "6427",
	"./explanation_slides/1_en.webp": "1a5c",
	"./explanation_slides/1_ru.jpg": "0421",
	"./explanation_slides/1_ru.webp": "e1cd",
	"./explanation_slides/1_ua.jpg": "625c",
	"./explanation_slides/1_ua.webp": "1838",
	"./explanation_slides/2_de.jpg": "0aae",
	"./explanation_slides/2_de.webp": "0574",
	"./explanation_slides/2_en.jpg": "ed82",
	"./explanation_slides/2_en.webp": "1058",
	"./explanation_slides/2_ru.jpg": "6332",
	"./explanation_slides/2_ru.webp": "904a",
	"./explanation_slides/2_ua.jpg": "6008",
	"./explanation_slides/2_ua.webp": "4f1a",
	"./explanation_slides/3_de.jpg": "2c8c",
	"./explanation_slides/3_de.webp": "f0ae",
	"./explanation_slides/3_en.jpg": "9c93",
	"./explanation_slides/3_en.webp": "a844",
	"./explanation_slides/3_ru.jpg": "df79",
	"./explanation_slides/3_ru.webp": "4191",
	"./explanation_slides/3_ua.jpg": "7e0c",
	"./explanation_slides/3_ua.webp": "a87e",
	"./explanation_slides/4_de.jpg": "5368",
	"./explanation_slides/4_de.webp": "6da1",
	"./explanation_slides/4_en.jpg": "40e6",
	"./explanation_slides/4_en.webp": "8d25",
	"./explanation_slides/4_ru.jpg": "26f0",
	"./explanation_slides/4_ru.webp": "12e2",
	"./explanation_slides/4_ua.jpg": "91e9",
	"./explanation_slides/4_ua.webp": "013f",
	"./icons/call.png": "3126",
	"./icons/check-circle-regular.svg": "affe",
	"./icons/chevron-left-solid.svg": "3b13",
	"./icons/chevron-right-solid.svg": "e4bd",
	"./icons/facebook.svg": "05bd",
	"./icons/linkedin.svg": "11db",
	"./icons/youtube.svg": "400a",
	"./infograms/audit_de.png": "9246",
	"./infograms/audit_en.png": "6246",
	"./infograms/audit_ru.png": "ef7a",
	"./infograms/audit_ua.png": "e5f1",
	"./infograms/infographic.svg": "07e9",
	"./logo.webp": "8e99",
	"./logos.png": "7d90",
	"./logos/agromat.jpg": "06a8",
	"./logos/agromat.webp": "b1e0",
	"./logos/agrosem.jpg": "e2ff",
	"./logos/agrosem.webp": "0769",
	"./logos/arcmet.jpg": "7d9d",
	"./logos/arcmet.webp": "29a7",
	"./logos/budpostach.jpg": "ad51",
	"./logos/budpostach.webp": "8eb0",
	"./logos/centra.jpg": "849f",
	"./logos/centra.webp": "4933",
	"./logos/eva.jpg": "5721",
	"./logos/eva.webp": "a0ea",
	"./logos/gs.jpg": "6425",
	"./logos/gs.webp": "a29f",
	"./logos/hc.jpg": "f656",
	"./logos/hc.webp": "0079",
	"./logos/metinvest.jpg": "f468",
	"./logos/metinvest.webp": "9474",
	"./logos/mhp.jpg": "87a9",
	"./logos/mhp.webp": "7da7",
	"./logos/rud.jpg": "8b1b",
	"./logos/rud.webp": "7c91",
	"./logos/shedro.jpg": "0886",
	"./logos/shedro.webp": "a54f",
	"./logos/sirius.jpg": "b264",
	"./logos/sirius.webp": "35bd",
	"./logos/terra.jpg": "7398",
	"./logos/terra.webp": "67a6",
	"./logos/tpk.jpg": "7034",
	"./logos/tpk.webp": "fe35",
	"./logos/ufc.jpg": "b1e3",
	"./logos/ufc.webp": "a795",
	"./logos/varus.jpg": "03ee",
	"./logos/varus.webp": "c8cb",
	"./map.png": "48dd",
	"./partners/ks.webp": "7fe1",
	"./partners/spilka.png": "6106",
	"./partners/spilka.webp": "8447",
	"./partners/vchasno.png": "8da5",
	"./partners/vchasno.webp": "4bcb",
	"./positions/1.png": "7f12",
	"./positions/2.png": "8515",
	"./positions/3.png": "7ce0",
	"./respondents/foto1.webp": "f598",
	"./respondents/foto2.webp": "8c9b",
	"./respondents/foto3.webp": "39fd",
	"./respondents/foto_ozuv-1.png": "05f7",
	"./respondents/foto_ozuv-2.png": "fda8",
	"./respondents/foto_ozuv.png": "e0e0",
	"./screen.png": "cd6c",
	"./screen.webp": "ddba",
	"./screen2.png": "cc01",
	"./screen2.webp": "65ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";